import React from 'react'
import FilterBox from './FilterBox'

type Props = {}

export default function Filters({}: Props) {
  return (
    <div className='filter-boxes'>
        <FilterBox fieldName='family' width={500} />
        <FilterBox fieldName='host' width={500} />
        <FilterBox fieldName='os' width={500} />
    </div>
  )
}